import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

// ----------------------------------------------------------------------------
// Usage Example

// Template:

// <app-alert>
//  {{ 'my_alert_text_line_1' | translate }}
//  <br>
//  {{ 'my_alert_text_line_1' | translate }}
// </app-alert>
// ----------------------------------------------------------------------------

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent {

  constructor() {}
}
